import React from 'react';
import { FiMoreHorizontal } from 'react-icons/fi';
import Dropdown from '@/app/components/Dropdown';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import moment from 'moment';
import { useState } from 'react';
import { useAuditorium } from '@/hooks/useAuditorium';
import Swal from 'sweetalert2';
import { ChatFile, ChatFileContent, ChatFileMeta, ChatFileTitle } from '@/components/custom/chat';
import { Button } from '@/components/ui/button';

export function AuditoriumViewCardFile(props) {
  const { messages, files, deleteFile } = useAuditorium();
  const { file, id } = props;
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });
  const [showContent, setShowContent] = useState(false);

  const handleView = () => {
    setShowContent(true);
    window.open(file.file.url, '_blank');
  };

  const handleDelete = () => {
    Swal.fire({
      title: 'Deseja mesmo excluir este arquivo?',
      text: 'Esta ação não poderá ser desfeita',
      confirmButtonText: 'Sim',
      showDenyButton: true,
      denyButtonText: 'Não',
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        deleteFile(id, file);
      }
    });
  };

  return (
    <ChatFile>
      <ChatFileContent>
        <ChatFileTitle>{file.filename}</ChatFileTitle>
        <ChatFileMeta>{`${file.user?.name ?? ''} em ${moment(file?.['created-at']).format('HH:mm')}`}</ChatFileMeta>
      </ChatFileContent>

      {isAdmin ? (
        <Dropdown>
          <Dropdown.Toggle>
            <span className="card__icon-wrapper">
              <FiMoreHorizontal className="card__icon" />
            </span>
          </Dropdown.Toggle>

          <Dropdown.Content>
            <Dropdown.Item onClick={handleView}>{'Visualizar'}</Dropdown.Item>
            <Dropdown.Item onClick={handleDelete}>{'Excluir'}</Dropdown.Item>
          </Dropdown.Content>
        </Dropdown>
      ) : (
        <Button
          variant="outline"
          size="sm"
          asChild
        >
          <a
            href={file.file.url}
            target="_blank"
            download
            rel="noopener noreferrer"
          >
            Baixar
          </a>
        </Button>
      )}
    </ChatFile>
  );
}
